export const stackedChartTransformer = (
  data: Array<any>,
  platforms: Array<any>,
  notPlatforms?: boolean
): Record<string, unknown> | null => {
  const xAxis: Array<string> = [];
  const allPlatforms: any = [];
  let allSeries: Array<any> | number[] = [];
  if (notPlatforms) {
    const series: any = [];
    data?.map((row) => {
      xAxis.push(
        row?.name ||
          row?.hashtag_name ||
          row?.title ||
          row?.username ||
          row?.topic_name
      );
      series.push(row?.hashtag_count || row?.tweets_count || row?.search_count);
    });
    allSeries = [{ data: series }];
  } else {
    data?.forEach((row: any) => {
      xAxis.push(row?.name || row?.hashtag_name || row?.title || row?.username);

      row?.platforms?.forEach((platform: any) => {
        allPlatforms.push(platform);
      });
    });

    platforms?.forEach((platform: any) => {
      /*       const series: any = { name: '', data: [] };
      const platformData = allPlatforms
        .filter((item: any) => {
          return item.name == platform.icon;
        })
        .map((item: any) => item.mentions);
      series.name = platform.name;
      series.data = platformData;
      allSeries.push(series); */
      const series: any = { name: platform?.name, data: [] };
      data?.forEach((ele: any) => {
        series?.data?.push(
          ele?.platforms?.find((item: any) => item?.name === platform?.icon)
            ?.mentions || '0',
        );
      });
      if(series.data.every( (val: any) => val === 0 ) ) {series.data=[]}
      allSeries.push(series);
    });
  }

  return { categories: xAxis, series: allSeries };
};
